export class Loader {
    /**
     * Ativa ou desativa o loader
     * @public
     */
    static ativarLoader() {
        let preloaderIt = document.getElementById('loading-wrapper');
        if(preloaderIt) {
            preloaderIt.classList.toggle('hide');
        }
    }
}
